module.exports = "/virtual-football-league/img/video/clubs/italy/lazio.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/italy/lazio.png
// module id = 350
// module chunks = 4